export default __webpack_public_path__ + "static/media/icon_status_inactive.88712217.svg";